module.exports = "pegasus_template/assets/theme2/facebook.png";